import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  const getPageNumbers = () => {
    const delta = 1
    const pages: (number | string)[] = []

    pages.push(1)

    const rangeStart = Math.max(2, currentPage - delta)
    const rangeEnd = Math.min(totalPages - 1, currentPage + delta)

    if (rangeStart > 2) {
      pages.push('...')
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(i)
    }

    if (rangeEnd < totalPages - 1) {
      pages.push('...')
    }

    if (totalPages > 1) {
      pages.push(totalPages)
    }

    return pages
  }

  return (
    <div className="relative left-1/2 mt-4 flex -translate-x-1/2 flex-wrap items-center justify-center gap-1 px-4 pb-6">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="hover:bg-gray-100 h-8 w-8 rounded border border-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <ChevronLeft className="mx-auto h-4 w-4" />
      </button>
      {getPageNumbers().map((page, index) =>
        page === '...' ? (
          <span key={`ellipsis-${index}`} className="px-2">
            <MoreHorizontal className="h-4 w-4" />
          </span>
        ) : (
          <button
            key={`page-${page}`}
            onClick={() => typeof page === 'number' && onPageChange(page)}
            className={`h-8 w-8 rounded ${
              currentPage === page
                ? 'bg-base-dark text-base-light'
                : 'hover:bg-gray-100 border border-gray-200'
            }`}
          >
            {page}
          </button>
        ),
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="hover:bg-gray-100 h-8 w-8 rounded border border-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <ChevronRight className="mx-auto h-4 w-4" />
      </button>
    </div>
  )
}
